// Roles the platform knows about but no screens are built for yet. The super
// admin's role screens leave them out until a portal exists for them.
export const ROLES_WITHOUT_SCREENS = ['TEAM_LEAD'];

export const hasScreens = (role: string): boolean => !ROLES_WITHOUT_SCREENS.includes((role || '').toUpperCase());
